"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZugentlastungList = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const Zugentlastung_1 = require("./Zugentlastung");
const INDEPENDENT_KEY = '*';
/**
 * The `ZugentlastungList` is responsible for
 * managing a list of `Zugentlastung`
 */
class ZugentlastungList extends ArticleList_1.ArticleList {
    static fromScratch() {
        return new ZugentlastungList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new ZugentlastungList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new ZugentlastungList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new ZugentlastungList();
        list.fromArray(arr);
        return list;
    }
    static fromExistingArtNr(json, cloneStrategy = 'deep') {
        const list = new ZugentlastungList();
        list.fromExistingArtNr(json, cloneStrategy);
        return list;
    }
    static fromInventedArtNr(json, cloneStrategy = 'deep') {
        const list = new ZugentlastungList();
        list.fromInventedArtNr(json, cloneStrategy);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.fromArray(json.map((itemJson) => Zugentlastung_1.Zugentlastung.fromJson(itemJson, cloneStrategy)), false);
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
        return this;
    }
    fromModel(model) {
        this.items = model.map((m) => Zugentlastung_1.Zugentlastung.fromModel(m));
        this.model = model;
        this.emitChange();
        return this;
    }
    fromArray(arr, notifiySubscriber = true) {
        if (arr && arr instanceof Array)
            this.items = arr;
        else
            this.items = [];
        if (notifiySubscriber)
            this.emitChange();
        return this;
    }
    fromExistingArtNr(json, cloneStrategy = 'deep') {
        this.fromArray(json.map((itemJson) => Zugentlastung_1.Zugentlastung.fromExistingArtNr(itemJson, cloneStrategy)));
    }
    fromInventedArtNr(json, cloneStrategy = 'deep') {
        this.fromArray(json.map((itemJson) => Zugentlastung_1.Zugentlastung.fromInventedArtNr(itemJson, cloneStrategy)));
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    clone() {
        return ZugentlastungList.fromArray(this.items.map((i) => i.clone()));
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /*************************************************************************************************
     * filter methods
     */
    /**
     * Filters the given Zugentlastungen against the given kette.
     * All AE montage types get recognized as valid
     * */
    filterByKette(kettenSerie) {
        const ze = this.toArray();
        if (!kettenSerie)
            return ze;
        return ze.filter((x) => this.isZugentlastungValidOnlyKette(x, kettenSerie));
    }
    /** Filters the given Zugentlastungen against the given kette and given ae-montage-types. */
    filterByKetteAndAE(kettenSerie, aeMontageTypes) {
        const ze = this.toArray();
        if (!kettenSerie || !aeMontageTypes)
            return ze;
        return ze.filter((x) => this.isZugentlastungValid(x, kettenSerie, aeMontageTypes));
    }
    isZugentlastungValid(ze, kettenSerie, aeMontageTypes) {
        var _a;
        // check if zugentlastung has independent series
        const independentSeries = (_a = ze.montage) === null || _a === void 0 ? void 0 : _a[INDEPENDENT_KEY];
        if (independentSeries) {
            if (independentSeries.length === 1 && independentSeries[0] === INDEPENDENT_KEY)
                return true;
            const validZugentlastung = independentSeries.some((x) => x === kettenSerie);
            if (validZugentlastung)
                return true;
        }
        // if independent series doesn't have target kettenSerie,
        // then search in the ae-montage-dependent ones
        return aeMontageTypes.some((aeType) => {
            var _a;
            const seriesValidForMontageType = (_a = ze.montage) === null || _a === void 0 ? void 0 : _a[aeType];
            return seriesValidForMontageType === null || seriesValidForMontageType === void 0 ? void 0 : seriesValidForMontageType.some((x) => x === kettenSerie);
        });
    }
    isZugentlastungValidOnlyKette(ze, kettenSerie) {
        // if any key of montage contains the series, the zugentlastung is valid.
        const montage = ze.montage;
        for (const key in montage) {
            if (montage.hasOwnProperty(key)) {
                if (montage[key].length === 1 && montage[key][0] === INDEPENDENT_KEY)
                    return true;
                if (montage[key].some((x) => x === kettenSerie))
                    return true;
            }
        }
        return false;
    }
    getCumulatedWeight() {
        return echain_shared_quantities_1.Weight.kg(this.items.reduce((cumulatedWeight, ze) => {
            return (cumulatedWeight += ze.weight ? ze.weight.kg : 0);
        }, 0));
    }
    /**
     * Returns a new list with ZugentlastungList filtered by set ArtNrCountry.
     */
    filterByArtNrCountry(artNrCountry) {
        return ZugentlastungList.fromArray(this.items.filter((article) => { var _a; return (_a = article.localizedArtNr) === null || _a === void 0 ? void 0 : _a[artNrCountry]; }));
    }
}
exports.ZugentlastungList = ZugentlastungList;
//# sourceMappingURL=ZugentlastungList.js.map